/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useEffect, useContext, useState } from 'react';

// MUST be the /native entry: the DOM and native builds are separate CJS
// bundles with distinct React ThemeContexts — a DOM ThemeProvider never
// delivers `theme` to native-styled components (blank-screen crash).
import { ThemeProvider } from 'styled-components/native';

import { Blue, Pink } from '../ui/colors';
import { CoreContext } from './CoreContext';

export function ThemeContext({ children }: { children?: React.ReactNode }) {
  const { currentProfile } = useContext(CoreContext);
  const [currentTheme, setCurrentTheme] = useState(Pink);

  useEffect(() => {
    if (currentProfile) {
      setCurrentTheme(currentProfile.theme === 'blue' ? Blue : Pink);
    }
  }, [currentProfile]);

  return (
    <>
      <ThemeProvider theme={currentTheme}>{children}</ThemeProvider>
    </>
  );
}
